// Jerarquia por prefijo: ['mcpUsuarios'] invalida todos los listados (cualquier filtro).
export const mcpUsuariosKeys = {
  all: ['mcpUsuarios'],
  lista: (hq, filtros) => ['mcpUsuarios', 'lista', hq, filtros],
};

export default mcpUsuariosKeys;
